import autoScroll from '../../functions/_autoScroll.js' // 自動スクロール
import '../animation/_pageLoading.js' // ページ全体のローディング演出
import './_validation.js' // バリデーション処理

/*
ContactForm7に以下の機能を付ける

・ステップ処理
　ページ遷移せずに確認画面の表示にする
　戻るボタンで戻れる

<div class="js-formArea js-validation formArea">
   [contact-form-7 id="00000" title="hoge"]
</div>

DOMイベント情報
https://contactform7.com/ja/dom-events/


ContactForm7のエディタ内では以下のようにボタンを配置する
,formAreaはmodule/_contactForm.scssを参照

<div class="formArea__input">
    <button type="button" class="js-formConfirm">
        確認画面へ
    </button>
</div>
<div class="formArea__confirm">
    <button type="button" class="js-formBack">
        修正する
    </button>
    [submit class:hoge class:fuga  "送信する"]
</div>
*/

//  ######  #####      ###     ####  #####
//    ##    ##  ##    ## ##   ##     ##
//    ##    #####    ##   ##  ##     #####
//    ##    ##  ##   #######  ##     ##
//    ##    ##   ##  ##   ##   ####  #####
/*
確認画面用にテキストを転写する
<div class="js-formTrace--tel">
[name="tel"]の内容がここに転写される
</div>

*/

// 入力欄に初期値が入っている事があるので、すぐにトレースタグを同期する
const inputList = document.querySelectorAll(
  '.js-formArea input:not([type="submit"]), .js-formArea select,.js-formArea textarea,.wpcf7-list-item-label'
)
for (const input of inputList) {
  inputTrace(input)
}

window.addEventListener('input', function (e) {
  const item = e.target.closest('.js-formTrace')
  if (!item) {
    return
  }

  setInterval(() => {
    for (const input of inputList) {
      inputTrace(input)
    }
  }, 300)
})

function inputTrace(item) {
  let value = ''

  if (item.type === 'checkbox' || item.type === 'radio') {
    // チェックボックスの場合の値取得

    const checkList = document.querySelectorAll('[name="' + item.name + '"]')

    for (const check of checkList) {
      if (!check.checked) {
        // 未チェックのチェックは飛ばす
        continue
      }
      if (value !== '') {
        // 選択ごとに改行を入れる
        value += '\n'
      }
      value += check.value
    }
  } else if (item.type === 'file') {
    // ファイルの場合の値取得
    if (item.files[0]) {
      value += item.files[0].name // ファイル名を設定
    }
  } else {
    value += item.value
  }

  value = escape(value) // サニタイズ
  value = value.replace(/\r?\n/g, '<br>') // 改行変換

  const target = document.querySelector('.js-formTrace--' + nameFix(item.name))
  if (target) {
    target.innerHTML = value
  }
}

//   ####  ######  #####  #####
//  ##       ##    ##     ##  ##
//   ###     ##    #####  #####
//     ##    ##    ##     ##
//  ####     ##    #####  ##

/*
.activeの着脱で入力画面を遷移させる
各ステップはバリデーションを通過しないと進行できない
完了画面はステップ50とする（下の処理で変更可能）

<div class="js-formStep-item js-formStep-item--1">
  .js-formStep-item.js-formStep-item--1 →　そのステップの時しか.activeを付けない
</div>
<div class="js-formStep-stack js-formStep-stack--1">
  .js-formStep-stack.js-formStep-stack--1 →　そのステップ以上なら.activeを付ける
</div>

<div class="js-formStep-item js-formStep-item--50">
  完了メッセージ
</div>


ステップ移動ボタン　ボタンはステップの数だけ作る
<div class="js-formStep-item js-formStep-item--1 active">
    <button type="button" class="js-formStep" data-step="2">
        次へ
    </button>
</div>
<div class="js-formStep-item js-formStep-item--3">
    <button type="button" class="js-formStep" data-step="1">
        戻る
    </button>
    <button type="button" class="js-formStep" data-step="3">
        次へ
    </button>
</div>
*/

let nowStep = 1

// ステップ遷移関数
window.stepShift = function (step) {
  // ステップが進む場合はバリデーションを確認する
  if (step > nowStep) {
    const valCheck = $('.wpcf7-form.init').validationEngine('validate')
    if (!valCheck) {
      autoScroll('#formArea', '#header', true)
      return
    }
  }
  nowStep = step

  const resetList = document.querySelectorAll('.js-formStep-item,.js-formStep-stack')
  for (const element of resetList) {
    element.classList.remove('active')
  }

  // js-formStep-itemをアクティブにする
  const itemList = document.getElementsByClassName('js-formStep-item--' + step)
  for (const element of itemList) {
    element.classList.add('active')
  }

  // js-formStep-stackをアクティブにする　現在のステップより小さい値もアクティブにする
  for (let index = step; index > 0; index--) {
    const itemList = document.getElementsByClassName('js-formStep-stack--' + index)
    for (const element of itemList) {
      element.classList.add('active')
    }
  }
}

// CF7の送信完了を確認したら最終ステップへ
document.addEventListener(
  'wpcf7mailsent',
  function (event) {
    window.stepShift('50')
  },
  false
)

if (document.getElementsByClassName('js-formStep')[0]) {
  window.stepShift(1) // 最初にステップをリセットする
  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-formStep')
    if (!item) {
      return
    }
    const step = parseInt(item.dataset.step, 10)
    if (!step) {
      return
    }
    window.stepShift(step)

    autoScroll('#formArea', '#header', true)
  })
}

//   ####  #####  ##     ##  ####
//  ##     ##     ####   ##  ##  ##
//   ###   #####  ##  ## ##  ##  ##
//     ##  ##     ##    ###  ##  ##
//  ####   #####  ##     ##  ####
// 送信を行ったらローディング表示にする
if (document.getElementsByClassName('wpcf7-submit')[0]) {
  window.addEventListener('click', function (e) {
    const item = e.target.closest('.wpcf7-submit')
    if (!item) {
      return
    }
    window.pageLoading('on') // ページをローディング表示にする
  })

  // 送信処理が終わったらページのローディング表示を切る
  document.addEventListener(
    'wpcf7submit',
    function (event) {
      window.pageLoading('off')
    },
    false
  )
}

//  #####  ##     ##  ######  #####  #####
//  ##     ####   ##    ##    ##     ##  ##
//  #####  ##  ## ##    ##    #####  #####
//  ##     ##    ###    ##    ##     ##  ##
//  #####  ##     ##    ##    #####  ##   ##
// Enterキーでの送信を無効にする
// キー操作監視

const textList = document.querySelectorAll('.js-formArea input')
for (const text of textList) {
  text.addEventListener('keypress', function (e) {
    disableEnter(e)
  })
  text.addEventListener('input', function (e) {
    disableEnter(e)
  })
}

function disableEnter(e) {
  // Enterによる遷移を防止
  if (e.code && e.code === 'Enter') {
    e.preventDefault() // デフォルトのイベントを除去
    return false
  }
}

//  #####  ##   ##  ##     ##   ####
//  ##     ##   ##  ####   ##  ##
//  #####  ##   ##  ##  ## ##  ##     ########  ########
//  ##     ##   ##  ##    ###  ##
//  ##      #####   ##     ##   ####

//  #####   ####   ####    ###    #####   #####
//  ##     ##     ##      ## ##   ##  ##  ##
//  #####   ###   ##     ##   ##  #####   #####
//  ##        ##  ##     #######  ##      ##
//  #####  ####    ####  ##   ##  ##      #####
// テキストをサニタイズする
function escape(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

//  ##     ##    ###    ###    ###  #####
//  ####   ##   ## ##   ## #  # ##  ##
//  ##  ## ##  ##   ##  ##  ##  ##  #####
//  ##    ###  #######  ##      ##  ##
//  ##     ##  ##   ##  ##      ##  #####

// 配列名の「[]」を除去して扱う
function nameFix(name) {
  return name.replace('[]', '')
}
